import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Search, Close, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Tooltip, IconButton, Grid, Checkbox, Collapse } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextField } from '@totalsoft/rocket-ui';

const PropertyDetailFiltersComponent = ({ filters, onChangeFilterValue }) => {
  const { t } = useTranslation();

  const [isExtended, setIsExtended] = useState(false);
  const onTextFilterChanged = (name, type) => event => {
    let value;
    if (type === 'Integer') {
      value = parseInt(event);
    } else {
      value = event;
    }
    onChangeFilterValue(name, value);
  };

  const onBooleanFilterChanged = name => event => {
    const value = event.target.checked;
    onChangeFilterValue(name, value === true ? true : null);
  };

  const resetFilters = name => () => {
    const value = null;
    onChangeFilterValue(name, value);
  };
  const toggleAdvancedFilters = () => {
    setIsExtended(!isExtended);
  };

  return (
    <Grid container flexDirection='column' gap={2}>
      <Grid container>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            label={t('Property.DetailsFilter')}
            value={filters.allFields || ''}
            onChange={onTextFilterChanged('allFields', 'String')}
            startAdornment={<Search />}
            fullWidth
            endAdornment={
              <>
                <Tooltip title={t('Tooltips.ResetFilters')}>
                  <IconButton onClick={resetFilters('allFields')}>
                    <Close />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t('Tooltips.ShowFilters')}>
                  <IconButton id={'listFilter_showFilters'} onClick={toggleAdvancedFilters}>
                    {isExtended ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Tooltip>
              </>
            }
          />
        </Grid>
      </Grid>
      <Collapse in={isExtended}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t('Property.OrderNo')}
              value={filters.orderNo || ''}
              onChange={onTextFilterChanged('orderNo', 'Integer')}
              fullWidth
              startAdornment={<Search />}
              endAdornment={
                <Tooltip title={t('Tooltips.ResetFilters')}>
                  <IconButton onClick={resetFilters('orderNo')}>
                    <Close />
                  </IconButton>
                </Tooltip>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t('Property.Code')}
              value={filters.code || ''}
              onChange={onTextFilterChanged('code', 'String')}
              fullWidth
              startAdornment={<Search />}
              endAdornment={
                <Tooltip title={t('Tooltips.ResetFilters')}>
                  <IconButton onClick={resetFilters('code')}>
                    <Close />
                  </IconButton>
                </Tooltip>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t('Property.PropertyValue')}
              value={filters.propertyValue || ''}
              onChange={onTextFilterChanged('propertyValue', 'String')}
              fullWidth
              startAdornment={<Search />}
              endAdornment={
                <Tooltip title={t('Tooltips.ResetFilters')}>
                  <IconButton onClick={resetFilters('propertyValue')}>
                    <Close />
                  </IconButton>
                </Tooltip>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t('Property.Description')}
              value={filters.description || ''}
              onChange={onTextFilterChanged('description', 'String')}
              fullWidth
              startAdornment={<Search />}
              endAdornment={
                <Tooltip title={t('Tooltips.ResetFilters')}>
                  <IconButton onClick={resetFilters('description')}>
                    <Close />
                  </IconButton>
                </Tooltip>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Checkbox color='primary' onChange={onBooleanFilterChanged('inactive')} />
            {t('Property.Inactive')}
          </Grid>
        </Grid>
      </Collapse>
    </Grid>
  );
};

PropertyDetailFiltersComponent.propTypes = {
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired
};

export default PropertyDetailFiltersComponent;
